import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  title: "Impulse response of a loudspeaker",
  description:
    "A loudspeaker can be, in a rough approach, considered as a single degree of freedom system. Modify the values of these physical parameters and observe the evolution of the impulse response h(t)",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0302a/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
